exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.theme-message,\n.theme-picker-dropdown {\n\tz-index: 99999 !important;\n}\n.theme-picker .el-color-picker__trigger {\n\theight: 26px !important;\n\twidth: 26px !important;\n\tpadding: 2px;\n}\n.theme-picker-dropdown .el-color-dropdown__link-btn {\n\tdisplay: none;\n}\n", ""]);

// exports
